import { ColumnOutputType } from 'app/component-library/table/column-output-type';
import { TableColumn } from 'app/component-library/table/table-column';
import { TableConfig } from 'app/component-library/table/table-config';
import { DateTimeFormatterPipe } from 'app/shared/pipes/date-time-formatter.pipe';
import { Widget } from 'app/viewmodels/dashboard/widget';
import { WidgetParameter } from 'app/viewmodels/dashboard/widget-parameter';
import { CONFIG } from '../../../../core/config';
import { DisplayData } from '../bar/DisplayData';
import { ValueSource } from '../widget-parameters/value-source.enum';
import { ValueType } from '../widget-parameters/value-type.enum';
import { ItemizedWidgetData } from './itemized-widget-data';

export class CompletedReportItemizedWidgetData extends ItemizedWidgetData {
  viewDataTableService: any;
  router: any;
  public createTableConfig(): TableConfig {
    const tableConfig = super.initializeTableConfig();
    tableConfig.columns = this.createColumns();
    return tableConfig;
  }

  public setFilterParameter(
    widget: Widget,
    widgetParam: WidgetParameter,
    reset: boolean
  ) {
    const paramIndex = widget.widgetItemizedDataParameters.findIndex(
      w => w.valueSource === ValueSource.InspectionMonthAndYear
    );

    if (paramIndex > -1) {
      if (!reset) {
        widget.widgetItemizedDataParameters[paramIndex] = widgetParam;
        return;
      }
      widget.widgetItemizedDataParameters.splice(paramIndex, 1);
      return;
    }
    if (
      !reset &&
      widgetParam.valueSource === ValueSource.InspectionMonthAndYear
    ) {
      widget.widgetItemizedDataParameters.push(widgetParam);
    }
  }

  protected createColumns(): TableColumn[] {
    const assetNameColumn = new TableColumn('Asset Name', 'AssetName');
    assetNameColumn.outputType = ColumnOutputType.Link;
    assetNameColumn.linkClickEvent = this.navigateToReports;

    const reportTypeColumn = new TableColumn('Report Type', 'ReportType');
    reportTypeColumn.outputType = ColumnOutputType.Link;
    reportTypeColumn.linkClickEvent = this.navigateToReports;

    const inspectionDateColumn = new TableColumn(
      'Inspection Date',
      'InspectionDate'
    );
    inspectionDateColumn.outputType = ColumnOutputType.Link;
    inspectionDateColumn.linkClickEvent = this.navigateToReports;

    inspectionDateColumn.formatterPipe = DateTimeFormatterPipe;
    inspectionDateColumn.formatterPipeArgs = ['L'];

    return [
      reportTypeColumn,
      assetNameColumn,
      inspectionDateColumn,
    ];
  }

  public createOverallTableHeaderColumn(): TableColumn {
    const headerColumn = new TableColumn('Month', 'label');
    headerColumn.outputType = ColumnOutputType.Link;
    headerColumn.linkClickEvent = this.completedReportsDrillDown;
    return headerColumn;
  }

  private completedReportsDrillDown = (data: DisplayData) => {
    const widgetParam = new WidgetParameter();
    widgetParam.widgetId = data.widgetId;
    widgetParam.valueSource = ValueSource.InspectionMonthAndYear;
    widgetParam.valueType = ValueType.String;
    widgetParam.displayName = data.label;
    widgetParam.stringValue = data.label;
    this.viewDataTableService.setItemizedDataWidgetParam.next(widgetParam);
  };

  private navigateToReports = (data: any) => {
    if (data.InspectionReportId) {
      const navigationString = data.ReportType.toString().toLowerCase() === 'inspection report'
        ? CONFIG.routes.idms.inspectionReport.root(data.InspectionReportId)
        : CONFIG.routes.thicknessManagement.thicknessReport.root(data.InspectionReportId);
      this.router.navigate([this.authService.urlCatalog + navigationString]);
    }
  };
}
